import { ReactNode } from "react";
import { BetSlipMode } from "../components/player/modals/BetSlipChrome.tsx";
import StraightBets from "../components/player/modals/strainght/StraightBets.tsx";
import StraightBetsResponsive from "../components/player/modals/strainght/strainghtResponsive/StraightBetsResponsive.tsx";
import OneBet from "../components/player/modals/strainght/strainghtResponsive/OneBet.tsx";
import { BetDetails } from "../models/MyBetModel.tsx";
import { unlockPageScroll } from "./scrollPageToTop.ts";

const SMALL_SLIP_MAX_WIDTH = 1300;

/** On small screens, auto-open the single-pick slip only. Extra picks wait for the Pick(s) button. */
export function openStraightBetSlipOnSelect(options: {
    incomingBets?: BetDetails[];
    showModal: (content?: ReactNode) => void;
    updateModalContent: (content: ReactNode) => void;
    setShowLimitAlert?: (value: boolean) => void;
    setErrorMessage?: (value: string) => void;
    onlyAutoOpenSingle?: boolean;
}) {
    const {
        incomingBets,
        showModal,
        updateModalContent,
        setShowLimitAlert,
        setErrorMessage,
        onlyAutoOpenSingle = true,
    } = options;

    const isSmallScreen = window.innerWidth < SMALL_SLIP_MAX_WIDTH;
    const pickCount = incomingBets?.length ?? 0;

    if (!isSmallScreen) {
        showModal(
            <StraightBets
                setShowLimitAlert={setShowLimitAlert}
                setErrorMessage={setErrorMessage}
            />
        );
        return;
    }

    if (onlyAutoOpenSingle && pickCount > 1) {
        unlockPageScroll();
        return;
    }

    if (pickCount > 1) {
        showModal(
            <StraightBets
                setShowLimitAlert={setShowLimitAlert}
                setErrorMessage={setErrorMessage}
            />
        );
        return;
    }

    showModal(
        <StraightBetsResponsive
            setShowLimitAlert={setShowLimitAlert}
            setErrorMessage={setErrorMessage}
            onBetConfirmation={() => {
                updateModalContent(
                    <OneBet
                        setShowLimitAlert={setShowLimitAlert}
                        setErrorMessage={setErrorMessage}
                    />
                );
            }}
        />
    );
}

export async function loadBetSlipContent(
    mode: BetSlipMode,
    alerts: {
        setShowLimitAlert?: (value: boolean) => void;
        setErrorMessage?: (value: string) => void;
    }
): Promise<ReactNode> {
    const setShowLimitAlert = alerts.setShowLimitAlert ?? (() => {});
    const setErrorMessage = alerts.setErrorMessage ?? (() => {});

    if (mode === "parlay") {
        const { default: ParlayBets } = await import("../components/player/modals/parlay/ParlayBets.tsx");
        return (
            <ParlayBets
                setShowLimitAlert={setShowLimitAlert}
                setErrorMessage={setErrorMessage}
            />
        );
    }

    const { default: StraightBets } = await import("../components/player/modals/strainght/StraightBets.tsx");
    return (
        <StraightBets
            setShowLimitAlert={setShowLimitAlert}
            setErrorMessage={setErrorMessage}
        />
    );
}
